// components/MultiPlatformPixelScript/eventMaps.ts — Peta nama event kanonis → per platform
// Satu sumber kebenaran (sebelumnya duplikat di tiap fire func). Meta memakai nama
// kanonis apa adanya sehingga tidak ada di peta ini.
const MAPS: Record<'google' | 'tiktok' | 'snack' | 'openai', Record<string, string>> = {
    google: {
        'PageView': 'page_view',
        'ViewContent': 'view_item',
        'AddToCart': 'add_to_cart',
        'InitiateCheckout': 'begin_checkout',
        'AddPaymentInfo': 'add_payment_info',
        'Purchase': 'purchase',
        'Lead': 'generate_lead',
        'CompleteRegistration': 'sign_up',
    },
    tiktok: {
        'PageView': 'ViewContent',
        'ViewContent': 'ViewContent',
        'AddToCart': 'AddToCart',
        'InitiateCheckout': 'InitiateCheckout',
        'AddPaymentInfo': 'AddPaymentInfo',
        'Purchase': 'CompletePayment',
        'Lead': 'SubmitForm',
        'CompleteRegistration': 'CompleteRegistration',
    },
    snack: {
        'PageView': 'PAGE_VIEW',
        'ViewContent': 'VIEW_CONTENT',
        'AddToCart': 'ADD_CART',
        'InitiateCheckout': 'START_CHECKOUT',
        'AddPaymentInfo': 'ADD_PAYMENT_INFO',
        'Purchase': 'PURCHASE',
        'Lead': 'LEAD',
        'CompleteRegistration': 'COMPLETE_REGISTRATION',
    },
    openai: {
        PageView: 'page_viewed', ViewContent: 'contents_viewed', AddToCart: 'items_added',
        InitiateCheckout: 'checkout_started', AddPaymentInfo: 'checkout_started',
        Lead: 'lead_created', Purchase: 'order_created', CompleteRegistration: 'lead_created',
    },
};

export function mapPlatformEvent(platform: 'google' | 'tiktok' | 'snack' | 'openai', eventName: string): string {
    return MAPS[platform]?.[eventName] || eventName;
}

const OPENAI_COMMERCE = new Set(['items_added', 'checkout_started', 'order_created']);

// Commerce = pakai amount/currency (docs commerce flow). Content view tidak.
export function isOpenAICommerceEvent(event: string): boolean {
    return OPENAI_COMMERCE.has(event);
}
